var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-form-field"
  }, [_c('label', {
    staticClass: "s-block s-text-grak-dark",
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._t("default"), _c('p', {
    staticClass: "s-text-sm s-mt-1",
    class: _vm.error ? 's-text-danger' : _vm.helpClass
  }, [_vm._v(_vm._s(_vm.error || _vm.help || ' '))])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }